import { BaseModel } from "./base";

export class Linha extends BaseModel {
  constructor(
    public id: number,
    public nome: string,
    public transportadora: string,
    public servico: string,
    public codigo: string,
    public itinerario: string,
    public origem: string,
    public destino: string,
    public tarifa: string,
    public temHorario?: boolean
  ) {
    super(id);
  }
}
